"use client"

import { LifeBuoy } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `LifeBuoyIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const LifeBuoyIcon = component(Icon)({ as: LifeBuoy })
